import React from "react";
import { Undo2, Redo2, Trash2 } from "lucide-react";
import { useT } from "../../lib/lang";

// Iter99 — Phase 2C §6.1: Undo/Redo/Clear-all commands. Disabled states
// (spec: "doivent être désactivés lorsque leurs piles respectives sont
// vides") are driven straight off `usePlanificationSession`'s
// `canUndo`/`canRedo` booleans — no local state to drift out of sync.
export const PlanificationHistoryActions = ({ canUndo, canRedo, hasObjects, onUndo, onRedo, onClearAll }) => {
  const [t] = useT();
  return (
    <div className="flex items-center gap-1 shrink-0" data-testid="planification-history-actions">
      <button
        type="button"
        data-testid="planification-undo-btn"
        disabled={!canUndo}
        onClick={onUndo}
        title={t.planificationUndo}
        aria-label={t.planificationUndo}
        className={`p-1.5 transition-colors ${canUndo ? "text-zinc-300 hover:text-emerald-300 hover:bg-zinc-900" : "text-zinc-700 cursor-not-allowed"}`}
      >
        <Undo2 className="w-4 h-4" />
      </button>
      <button
        type="button"
        data-testid="planification-redo-btn"
        disabled={!canRedo}
        onClick={onRedo}
        title={t.planificationRedo}
        aria-label={t.planificationRedo}
        className={`p-1.5 transition-colors ${canRedo ? "text-zinc-300 hover:text-emerald-300 hover:bg-zinc-900" : "text-zinc-700 cursor-not-allowed"}`}
      >
        <Redo2 className="w-4 h-4" />
      </button>
      <button
        type="button"
        data-testid="planification-clear-all-btn"
        disabled={!hasObjects}
        onClick={onClearAll}
        title={t.planificationClearAllDrawings}
        aria-label={t.planificationClearAllDrawings}
        className={`p-1.5 transition-colors ${hasObjects ? "text-zinc-300 hover:text-red-300 hover:bg-zinc-900" : "text-zinc-700 cursor-not-allowed"}`}
      >
        <Trash2 className="w-4 h-4" />
      </button>
    </div>
  );
};
